import script from "./PeopleGroupInvitationAccept.vue?vue&type=script&setup=true&lang=js"
export * from "./PeopleGroupInvitationAccept.vue?vue&type=script&setup=true&lang=js"

import "./PeopleGroupInvitationAccept.vue?vue&type=style&index=0&id=3b3d2494&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b3d2494"]])

export default __exports__